import { Injectable } from '@angular/core';
import { ViewProductInfoHandlerService } from '../../buyer/services/view-product-info-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptItemsService {

  items: ReceiptItem[];
  defaultItem: ReceiptItem;
  constructor(public vpihs: ViewProductInfoHandlerService) { }

  /**
   * @description function to set the ReceiptItem array with the items to be displayed in each row of the receipt
   */
  setReceiptItems(){
    this.items = [];
    this.defaultItem = {
      name: 'Item',
      quantity: this.vpihs.quantity,
      amount: this.vpihs['_subTotal'],
      price: this.vpihs['_subTotal']/ this.vpihs.quantity
    };

    if (this.isEvent()) {
      this.items=[];
      this.vpihs.viewInfoObject.extras.selectedTickets.forEach(ticket => {
        this.items.push({
          name: ticket.ticketName,
          quantity: Number.parseFloat(ticket.ticketQuantity),
          amount: Number.parseFloat(ticket.ticketPrice) / this.vpihs.Dividing * Number.parseFloat(ticket.ticketQuantity),
          price: Number.parseFloat(ticket.ticketPrice) / this.vpihs.Dividing
        })
      });
    } else if(this.isInvoice()) {
      this.vpihs.viewInfoObject.product.InvoiceItems.forEach(item => {
        this.items.push({
            name: item.name,
            quantity: Number.parseFloat(item.quantity),
            amount: Number.parseFloat(item.price) / this.vpihs.Dividing * Number.parseFloat(item.quantity),
            price: Number.parseFloat(item.price) / this.vpihs.Dividing
        })
      });
    } else if (this.isCustomPayment()) {
      this.defaultItem.name = 'Custom Payment';
      this.items.push(this.defaultItem);
    } else if(this.isPhysicalOrQuickPayment()){
      this.defaultItem.name = this.vpihs.viewInfoObject.product.productName;
      this.items.push(this.defaultItem);
    } else { // fallback for any unhandled type of products
      this.items.push(this.defaultItem);
    }
  }

  /**
   * @description to check if the receipt has event product
   */
  isEvent() {
    return this.vpihs.viewInfoObject.extras && this.vpihs.viewInfoObject.extras.selectedTickets;
  }

  /**
   * @description to check if the receipt has invoice product
   */
  isInvoice() {
    return this.vpihs.viewInfoObject.product && this.vpihs.viewInfoObject.product.InvoiceItems
  }

  /**
   * @description to check if the receipt has custom payment product
   */
  isCustomPayment() {
    return this.vpihs.viewInfoObject.extras && this.vpihs.viewInfoObject.extras.isCustomPayment
  }

  /**
   * @description to check if the receipt has physical product or quick payment
   */
  isPhysicalOrQuickPayment(){
    return this.vpihs.viewInfoObject.product
  }
}

export interface ReceiptItem {
  name: string;
  quantity: number;
  amount: number;
  price: number;
}
